import React from "react";
import { cn } from "@/lib/utils";

export const LOGO_SRC = `${process.env.PUBLIC_URL}/ec-dream-logo-512.png`;

export const BrandLogo = ({ size = "w-10 h-10", showText = true, text = "EC DREAM", textClass = "", testid = "brand-logo" }) => (
  <span className="inline-flex items-center gap-2.5" data-testid={testid}>
    <img src={LOGO_SRC} alt="EC DREAM logo" className={`${size} object-contain shrink-0 rounded-full`} />
    {showText && <span className={`font-head font-extrabold tracking-wide text-gradient ${textClass}`}>{text}</span>}
  </span>
);

export const Loader = ({ label = "Loading..." }) => (
  <div className="flex flex-col items-center justify-center py-24 text-gray-500 gap-4" data-testid="loader">
    <div className="relative w-16 h-16">
      <img src={LOGO_SRC} alt="EC DREAM" className="w-16 h-16 rounded-full object-contain animate-pulse" />
      <div className="absolute -inset-1.5 border-2 border-yellow-500 border-t-transparent rounded-full animate-spin" />
    </div>
    <span className="text-sm">{label}</span>
  </div>
);

export const StatCard = ({ icon: Icon, label, value, sub, accent = "orange", testid }) => {
  const colors = {
    orange: "text-orange-400 bg-orange-500/10",
    gold: "text-yellow-400 bg-yellow-500/10",
    green: "text-emerald-400 bg-emerald-500/10",
    blue: "text-blue-400 bg-blue-500/10",
    red: "text-red-400 bg-red-500/10",
    purple: "text-purple-400 bg-purple-500/10",
  };
  return (
    <div className="ec-card p-6 transition-all animate-fadeUp" data-testid={testid}>
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs uppercase tracking-widest text-gray-500 font-semibold">{label}</p>
          <p className="mt-2 text-2xl sm:text-3xl font-extrabold font-head text-white">{value}</p>
          {sub && <p className="mt-1 text-sm text-gray-400">{sub}</p>}
        </div>
        {Icon && (
          <div className={cn("w-11 h-11 rounded-xl flex items-center justify-center", colors[accent])}>
            <Icon className="w-5 h-5" />
          </div>
        )}
      </div>
    </div>
  );
};

export const PageHeader = ({ title, subtitle, action }) => (
  <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
    <div>
      <h1 className="font-head text-2xl sm:text-3xl font-bold text-white">{title}</h1>
      {subtitle && <p className="text-gray-400 mt-1 text-sm">{subtitle}</p>}
    </div>
    {action}
  </div>
);

export const Badge = ({ children, className }) => (
  <span className={cn("inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold border", className)}>
    {children}
  </span>
);

export const Empty = ({ label }) => (
  <div className="ec-card p-12 text-center text-gray-500" data-testid="empty-state">{label}</div>
);
